<!-- version 2021/05/20 -->
<template>
    <span>{{ text }}</span>
</template>

<script>
    export default {
        props: {
            text: String
        }
    }
</script>

<style lang="sass" scoped>
  span
      display: inline-block
      margin-left: 10px
      margin-right: 50px
      text-align: center
      font-size: 12px
      color: white
      background-color: #FF736E
      border-radius: 3px
      padding: 0 10px
      vertical-align: text-top
</style>
